<template >
  <div class="component-container">
    <app-navigation v-if="!$props.onlyMaps"></app-navigation>
    <form>
      <div class="main-div">
        <div class="demo">
          <div class="p-2 header">
            <h3 class="text-left">Pull Back Policy (AR)</h3>
          </div>
          <vue-editor v-model="content"></vue-editor>
          <div class="p-2 header">
            <h3 class="text-left">Pull Back Policy (EN)</h3>
          </div>
          <vue-editor v-model="content_en"></vue-editor>
        </div>
        <button
          class="btn btn-primary float-right mt-4"
          v-if="!formState.loading"
          @click="editPullBackPolicy"
        >
          Edit Pull Back Policy
        </button>
        <button
          class="btn btn-primary float-right mt-4"
          type="button"
          disabled
          v-else
        >
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading
        </button>
      </div>
    </form>
    <div class="alert alert-danger" role="alert" v-if="formState.error">
      <p>{{ formState.error }}</p>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import Navigation from "../components/Navigation.vue";
import axios from "axios";
import { herokuUrl } from "../apiConfig";
import { getCookie } from "../cookie.js";
import logOut from "../scripts/utils";

export default {
  props: ["onlyMaps"],
  name: "Demo",

  data() {
    return {
      content: "waiting ....",
      content_en: "waiting ....",
      policies: null,
      formState: {
        loading: false,
        error: null,
      },
    };
  },
  mounted() {
    this.setEditorContent();
  },
  methods: {
    setEditorContent: function () {
      this.formState.loading = true;
      return Promise.all([
        axios.get(`${herokuUrl}/policies`, null, {
          headers: {
            Authorization: getCookie("user"),
          },
        }),
      ])
        .then((res) => {
          console.log(res);
          this.content = res[0].data.policies[0]["pull_back_policy"];
          this.content_en = res[0].data.policies[0]["pull_back_policy_en"];
          this.policies = res[0].data.policies[0];
          this.formState.loading = false;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert("Emails fetching failed, " + err.response.data.message);
          }
          // window.location.reload();
        });
    },
    editPullBackPolicy: function () {
      this.formState.loading = true;
      if (!this.content || !this.content_en) {
        this.formState.error = "All Fields Are Required";
        this.formState.loading = false;
        return;
      } else {
        console.log("submitted" + this.content);
        this.formState.loading = true;
        return axios
          .post(
            `${herokuUrl}/edit_policies`,
            {
              id: this.policies["id"],
              privacy_policy: this.policies.privacy_policy,
              privacy_policy_en: this.policies.privacy_policy_en,
              terms: this.policies.terms,
              terms_en: this.policies.terms_en,
              pull_back_policy: this.content,
              pull_back_policy_en: this.content_en,
              delivery: this.policies.delivery,
              delivery_en: this.policies.delivery_en
            },
            {
              headers: {
                Authorization: getCookie("user"),
              },
            }
          )
          .then(() => {
            alert("privacy policy was Edited successfully");
            this.formState.loading = false;
          })
          .catch((err) => {
            if (err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;
              alert(
                "There was a problem editing the privacy policy " +
                  err.response.data.message
              );
            }
          });
      }
    },
  },

  components: {
    appNavigation: Navigation,
    VueEditor,
  },
};
</script>
<style lang='scss' scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
.component-container {
  min-height: 100%;
  display: flex;
}

.main-div {
  padding: 50px;
  width: 80%;

  button {
    margin: 0 auto;
    padding: 10px 30px;
    font-size: 16px;
  }

  .header {
    padding-top: 16px !important;
    background: black;
    color: #b78b1e;
  }
}
</style>